import { useContext, useState } from 'react'
import { createPortal } from 'react-dom'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import ExportModal from './ExportModal'
import Tooltip from './Tooltip'
import CardHeaderSlotContext from '../../StateManagment/CardHeaderSlot'

/**
 * Exportknop voor een kaart of tabel. Zet het icoon in de onderbalk van de
 * kaart wanneer die er is (naast het filtericoon), en anders gewoon op de plek
 * van de aanroeper. Klikken opent het exportvenster.
 *
 * @param {object} props
 * @param {string} props.pageHeader - Titel van het exportvenster
 * @param {import('./ExportModal').ExportItem[]} props.items - Waar de gebruiker uit kan kiezen
 * @param {string} props.itemsLabel - Kop boven de lijst, bijv. 'Deelnemers'
 * @param {(selection: object) => void} props.onExport - Krijgt de keuze van de gebruiker
 * @param {() => void} [props.onOpen] - Aangeroepen zodra het venster opengaat; om gegevens op te halen die alleen de export nodig heeft
 * @param {Date|null} [props.defaultStartDate] - Voorgevulde begindatum
 * @param {Date|null} [props.defaultEndDate] - Voorgevulde einddatum
 * @param {string} [props.tooltip] - Tekst bij het icoon
 * @param {string} [props.emptyMessage] - Tekst wanneer er niets te kiezen valt
 * @param {import('./ExportModal').ExportGroup[]} [props.groups] - Groepen om (uit) te vinken, bijv. statussen
 * @param {string} [props.groupsLabel] - Kop boven de groepen
 * @param {string} [props.groupNoun] - Eén groep in de waarschuwing, bijv. 'status'
 * @returns {JSX.Element}
 */
const ExportBar = ({
    pageHeader,
    items = [],
    itemsLabel,
    onExport,
    onOpen,
    defaultStartDate = null,
    defaultEndDate = null,
    tooltip = 'Exporteren',
    emptyMessage,
    groups,
    groupsLabel,
    groupNoun,
}) => {
    const slots = useContext(CardHeaderSlotContext)
    const [modalOpen, setModalOpen] = useState(false)

    const trigger = (
        <span
            className="dashboard-export-trigger"
            onClick={() => {
                // Eerst melden, dan openen: een aanroeper die hierop een
                // listener opzet, heeft de snapshot al onderweg tegen de tijd
                // dat de gebruiker op 'Exporteren' klikt.
                if (onOpen) onOpen()
                setModalOpen(true)
            }}
        >
            <Tooltip content={tooltip} top="-35px">
                <FileDownloadOutlinedIcon className="dashboard-card-options-icon" />
            </Tooltip>
        </span>
    )

    return (
        <>
            {slots?.filterSlot ? createPortal(trigger, slots.filterSlot) : trigger}
            <ExportModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                pageHeader={pageHeader}
                items={items}
                itemsLabel={itemsLabel}
                onExport={onExport}
                defaultStartDate={defaultStartDate}
                defaultEndDate={defaultEndDate}
                emptyMessage={emptyMessage}
                groups={groups}
                groupsLabel={groupsLabel}
                groupNoun={groupNoun}
            />
        </>
    )
}

export default ExportBar
